import { getItem } from "@swa-ui/persistence";

export const getChaseStorage = () => {
  const configuration = {
    persistDefault: false,
    storageType: "session",
    timeToLiveInMinutes: 30,
  };

  return getItem("chaseStorage", {}, configuration);
};
